import { render } from "./IdentificationStep.vue?vue&type=template&id=4359737c"
import script from "./IdentificationStep.vue?vue&type=script&lang=js"
export * from "./IdentificationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__